import { useSession } from '@descope/react-sdk';
import { Navigate, Outlet, createFileRoute } from '@tanstack/react-router';
import { ReactNode } from 'react';

import { ApiKeyHeader } from '@/features/api-key/components/api-key-header';

function AuthedLayout({ children }: { children: ReactNode }) {
  return (
    <div className="px-10 flex min-h-screen w-full flex-col items-center justify-center">
      <div className="gap-10 flex w-full max-w-[880px] flex-col items-start justify-center">
        <ApiKeyHeader />
        {children}
      </div>
    </div>
  );
}

function AuthedRoute() {
  const { isAuthenticated, isSessionLoading } = useSession();

  // Wait for Descope to restore/refresh the session before deciding. Reading the
  // session token synchronously (e.g. in `beforeLoad`) races the async refresh and
  // bounces an authenticated user to /sign-in, which then redirects back — a loop.
  if (isSessionLoading) {
    return null;
  }

  if (!isAuthenticated) {
    return <Navigate to="/sign-in" />;
  }

  return (
    <AuthedLayout>
      <Outlet />
    </AuthedLayout>
  );
}

export const Route = createFileRoute('/_authed')({
  component: AuthedRoute,
});
